import React from 'react';
import { Spinner } from '../general/Spinner';
import { Text } from '../general/Text';

export interface PrimaryButtonProps {
  text: string;
  callback: () => void;
  isLoading?: boolean;
  isEnabled?: boolean;
  foregroundColor?: string;
  backgroundColor?: string;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  text,
  callback,
  isLoading = false,
  isEnabled = true,
  foregroundColor = 'var(--text-primary)',
  backgroundColor = 'var(--brand-primary)'
}) => {
  const buttonStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    backgroundColor: isEnabled ? backgroundColor : 'var(--color-disabled)',
    color: foregroundColor,
    padding: '8px',
    border: `1px solid ${isEnabled ? backgroundColor : 'var(--color-disabled)'}`,
    borderRadius: '8px',
    cursor: isEnabled ? 'pointer' : 'not-allowed',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '48px',
    width: '100%',
    transition: 'background-color 0.2s, color 0.2s, filter 0.2s'
  };

  return (
    <>
      <style>{`
        .primary-button-hover:enabled:hover {
          filter: brightness(0.9) !important;
        }
      `}</style>
      <button
        onClick={!isLoading && isEnabled ? callback : undefined}
        disabled={!isEnabled}
        style={buttonStyle}
        className='primary-button-hover'
      >
        {isLoading ? (
          <Spinner size={16} color={foregroundColor} />
        ) : (
          <Text
            variant='body1'
            style={{
              color: isEnabled ? foregroundColor : 'var(--color-disabled-text)'
            }}
          >
            {text}
          </Text>
        )}
      </button>
    </>
  );
};
